<template>
  <div class="page-wrapper">
    <div class="page-container">
      
      <!-- Sarlavha va amallar -->
      <div class="page-header-box">
        <div>
          <h1 class="page-main-title">Kafedra vs Shaxsiy ish reja</h1>
          <p class="page-subtitle">Kafedralar umumiy o'quv yuklamasi va o'qituvchilar shaxsiy ish rejalari taqsimotining qiyosiy tahlili</p>
        </div>
        <div class="header-actions">
          <button class="btn-action btn-excel" @click="exportToExcel" :disabled="loading || filteredItems.length === 0">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
            Excelga yuklash
          </button>
          <button class="btn-action btn-refresh" @click="fetchData" :disabled="loading">
            <svg :class="{ 'spinning': loading }" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
            Yangilash
          </button>
        </div>
      </div>

      <!-- KPI Kartochkalar (Umumiy statistika) -->
      <div class="kpi-grid">
        <div class="kpi-card card-blue">
          <div class="kpi-header">
            <span class="kpi-label">Kafedralar soni</span>
            <div class="kpi-icon-badge icon-blue">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
            </div>
          </div>
          <div class="kpi-value">{{ summary.totalDepartments || 0 }} ta</div>
          <div class="kpi-subtext">
            <span class="text-emerald-600 font-semibold">{{ summary.matchedCount || 0 }} to'liq</span> &bull; 
            <span class="text-amber-600 font-semibold">{{ summary.underCount || 0 }} kam</span> &bull; 
            <span class="text-purple-600 font-semibold">{{ summary.overCount || 0 }} ortiqcha</span>
          </div>
        </div>

        <div class="kpi-card card-indigo">
          <div class="kpi-header">
            <span class="kpi-label">Kafedra yuklamasi</span>
            <div class="kpi-icon-badge icon-indigo">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
            </div>
          </div>
          <div class="kpi-value">{{ formatHours(summary.kafedra?.jami) }} <span class="kpi-unit">soat</span></div>
          <div class="kpi-subtext">
            Auditoriya: <b>{{ formatHours(summary.kafedra?.auditoriya) }}</b> &bull; Tashqari: <b>{{ formatHours(summary.kafedra?.tashqari) }}</b>
          </div>
        </div>

        <div class="kpi-card card-emerald">
          <div class="kpi-header">
            <span class="kpi-label">Shaxsiy ish reja (Taqsimlangan)</span>
            <div class="kpi-icon-badge icon-emerald">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>
            </div>
          </div>
          <div class="kpi-value text-emerald-700">{{ formatHours(summary.shaxsiyReja?.jami) }} <span class="kpi-unit">soat</span></div>
          <div class="kpi-subtext">
            Auditoriya: <b>{{ formatHours(summary.shaxsiyReja?.auditoriya) }}</b> &bull; Tashqari: <b>{{ formatHours(summary.shaxsiyReja?.tashqari) }}</b>
          </div>
        </div>

        <div class="kpi-card" :class="summaryDiffClass">
          <div class="kpi-header">
            <span class="kpi-label">Taqsimot balansi (Farq)</span>
            <div class="kpi-icon-badge" :class="summaryBadgeIconClass">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 14 14"></polyline></svg>
            </div>
          </div>
          <div class="kpi-value" :class="summaryDiffTextClass">
            {{ formatDiffValue(summary.diff?.jami) }} <span class="kpi-unit">soat</span>
          </div>
          <div class="kpi-subtext">
            Umumiy taqsimot foizi: <b class="font-bold">{{ summary.diff?.percent || 0 }}%</b>
          </div>
        </div>
      </div>

      <!-- Filtrlar paneli -->
      <div class="filters-card">
        <div class="filters-grid">
          <!-- O'quv yili -->
          <div class="filter-item">
            <label>O'quv yili:</label>
            <select v-model="selectedYear" class="filter-control" @change="fetchData">
              <option value="2026-2027">2026-2027</option>
              <option value="2025-2026">2025-2026</option>
              <option value="2024-2025">2024-2025</option>
            </select>
          </div>

          <!-- Semestr -->
          <div class="filter-item">
            <label>Semestr:</label>
            <select v-model="selectedSemestr" class="filter-control" @change="fetchData">
              <option value="hammasi">Barcha semestrlar (Hammasi)</option>
              <option value="kuzgi">Kuzgi semestr</option>
              <option value="bahorgi">Bahorgi semestr</option>
            </select>
          </div>

          <!-- Fakultet -->
          <div class="filter-item">
            <label>Fakultet:</label>
            <select v-model="selectedFaculty" class="filter-control">
              <option value="">Barcha fakultetlar</option>
              <option v-for="f in facultiesList" :key="f.id" :value="f.id">{{ f.name }}</option>
            </select>
          </div>

          <!-- Holati -->
          <div class="filter-item">
            <label>Holati:</label>
            <select v-model="selectedStatus" class="filter-control">
              <option value="">Barcha holatlar</option>
              <option value="MATCH">To'liq taqsimlangan (Mos)</option>
              <option value="UNDER">Kam taqsimlangan (Qoldiq bor)</option>
              <option value="OVER">Ortiqcha taqsimlangan</option>
            </select>
          </div>

          <!-- Qidiruv -->
          <div class="filter-item search-item">
            <label>Kafedra qidirish:</label>
            <div class="search-input-wrap">
              <input type="text" v-model="searchQuery" placeholder="Kafedra nomini kiriting..." class="filter-control" />
              <button v-if="searchQuery" class="clear-search-btn" @click="searchQuery = ''">✕</button>
            </div>
          </div>

          <!-- Tozalash -->
          <div class="filter-item btn-clear-wrap">
            <button class="btn-clear-filters" @click="clearFilters" title="Barcha filtrlarni bekor qilish">
              Tozalash
            </button>
          </div>
        </div>
      </div>

      <!-- Asosiy Qiyosiy Jadval -->
      <div class="table-card">
        <div v-if="loading" class="table-loading-box">
          <div class="spinner-large"></div>
          <p>Kafedra va Shaxsiy ish reja ma'lumotlari tahlil qilinmoqda...</p>
        </div>

        <div v-else class="table-responsive">
          <table class="comparison-table">
            <thead>
              <tr class="thead-group-row">
                <th rowspan="2" class="th-num">#</th>
                <th rowspan="2" class="th-name text-left">Kafedra nomi</th>
                <th rowspan="2" class="th-faculty text-left">Fakultet</th>
                <th colspan="3" class="th-group th-kafedra-grp">Kafedra yuklamasi (soat)</th>
                <th colspan="3" class="th-group th-reja-grp">Shaxsiy ish reja (soat)</th>
                <th colspan="3" class="th-group th-diff-grp">Farq (Qoldiq soat)</th>
                <th rowspan="2" class="th-percent">Taqsimot</th>
                <th rowspan="2" class="th-staff">Xodimlar</th>
                <th rowspan="2" class="th-status">Holati</th>
                <th rowspan="2" class="th-actions">Amallar</th>
              </tr>
              <tr class="thead-sub-row">
                <th class="th-sub">Audit.</th>
                <th class="th-sub">Tashqari</th>
                <th class="th-sub th-total-sub">Jami</th>

                <th class="th-sub">Audit.</th>
                <th class="th-sub">Tashqari</th>
                <th class="th-sub th-total-sub">Jami</th>

                <th class="th-sub">Audit.</th>
                <th class="th-sub">Tashqari</th>
                <th class="th-sub th-total-sub">Jami</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="filteredItems.length === 0">
                <td colspan="15" class="py-12 text-center text-gray-500 font-medium">
                  Ma'lumot topilmadi
                </td>
              </tr>

              <tr 
                v-for="(row, index) in filteredItems" 
                :key="row.departmentId"
                class="comparison-row"
                :class="{ 'row-highlighted': selectedDeptDetail?.departmentId === row.departmentId }"
                @click="openDepartmentDetail(row)"
              >
                <td class="text-center font-medium text-gray-400">{{ index + 1 }}</td>
                <td class="cell-name font-semibold text-gray-800">
                  <div class="name-box">
                    <span class="dept-title">{{ row.kafedraName }}</span>
                    <span class="dept-id-badge">ID: {{ row.departmentId }}</span>
                  </div>
                </td>
                <td class="cell-faculty text-gray-600 text-sm">{{ row.facultyName }}</td>

                <!-- Kafedra yuklamasi -->
                <td class="text-center cell-num text-blue-800">{{ formatHours(row.kafedra.auditoriya) }}</td>
                <td class="text-center cell-num text-indigo-800">{{ formatHours(row.kafedra.tashqari) }}</td>
                <td class="text-center cell-num font-bold text-blue-900 bg-blue-50/50">{{ formatHours(row.kafedra.jami) }}</td>

                <!-- Shaxsiy ish reja -->
                <td class="text-center cell-num text-emerald-800">{{ formatHours(row.shaxsiyReja.auditoriya) }}</td>
                <td class="text-center cell-num text-teal-800">{{ formatHours(row.shaxsiyReja.tashqari) }}</td>
                <td class="text-center cell-num font-bold text-emerald-900 bg-emerald-50/50">{{ formatHours(row.shaxsiyReja.jami) }}</td>

                <!-- Farq -->
                <td class="text-center cell-num font-medium" :class="getDiffCellClass(row.diff.auditoriya)">
                  {{ formatDiffDisplay(row.diff.auditoriya) }}
                </td>
                <td class="text-center cell-num font-medium" :class="getDiffCellClass(row.diff.tashqari)">
                  {{ formatDiffDisplay(row.diff.tashqari) }}
                </td>
                <td class="text-center cell-num font-bold" :class="getDiffTotalClass(row.diff.jami)">
                  {{ formatDiffDisplay(row.diff.jami) }}
                </td>

                <!-- Foiz -->
                <td class="text-center cell-percent">
                  <div class="percent-container">
                    <div class="progress-bar-bg">
                      <div class="progress-bar-fill" :style="{ width: Math.min(row.diff.percent, 100) + '%', backgroundColor: getProgressBarColor(row.diff.percent) }"></div>
                    </div>
                    <span class="percent-text font-bold">{{ row.diff.percent }}%</span>
                  </div>
                </td>

                <!-- Xodimlar -->
                <td class="text-center text-sm text-gray-700">
                  <span class="font-bold text-emerald-700">{{ row.shaxsiyReja.teachersCount }}</span>
                  <span class="text-gray-400 text-xs"> / {{ row.shaxsiyReja.totalStaffCount }}</span>
                </td>

                <!-- Holati -->
                <td class="text-center">
                  <span class="status-pill" :class="getStatusBadgeClass(row.status)">
                    {{ row.statusLabel }}
                  </span>
                </td>

                <!-- Amallar -->
                <td class="text-center" @click.stop>
                  <button class="btn-detail" @click="openDepartmentDetail(row)" title="Kafedra tafsilotlarini ko'rish">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    Batafsil
                  </button>
                </td>
              </tr>
            </tbody>

            <!-- Jami qator (Footer) -->
            <tfoot v-if="filteredItems.length > 0" class="tfoot-totals">
              <tr>
                <td colspan="3" class="text-right font-bold pr-4">JAMI (Tanlanganlar):</td>
                <!-- Kafedra -->
                <td class="text-center font-bold text-blue-900">{{ formatHours(tableTotals.kafedraAudit) }}</td>
                <td class="text-center font-bold text-indigo-900">{{ formatHours(tableTotals.kafedraTashqari) }}</td>
                <td class="text-center font-bold text-blue-900 bg-blue-100/60">{{ formatHours(tableTotals.kafedraJami) }}</td>
                <!-- Reja -->
                <td class="text-center font-bold text-emerald-900">{{ formatHours(tableTotals.rejaAudit) }}</td>
                <td class="text-center font-bold text-teal-900">{{ formatHours(tableTotals.rejaTashqari) }}</td>
                <td class="text-center font-bold text-emerald-900 bg-emerald-100/60">{{ formatHours(tableTotals.rejaJami) }}</td>
                <!-- Farq -->
                <td class="text-center font-bold" :class="getDiffCellClass(tableTotals.diffAudit)">{{ formatDiffDisplay(tableTotals.diffAudit) }}</td>
                <td class="text-center font-bold" :class="getDiffCellClass(tableTotals.diffTashqari)">{{ formatDiffDisplay(tableTotals.diffTashqari) }}</td>
                <td class="text-center font-extrabold text-base" :class="getDiffTotalClass(tableTotals.diffJami)">{{ formatDiffDisplay(tableTotals.diffJami) }}</td>
                <!-- Foiz -->
                <td class="text-center font-bold text-gray-800">{{ tableTotals.overallPercent }}%</td>
                <!-- Xodimlar -->
                <td class="text-center font-bold text-emerald-800">{{ tableTotals.totalTeachers }} ta</td>
                <td colspan="2"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <!-- Kafedra batafsil tahlili Drawer/Modal -->
      <div v-if="showDetailModal" class="modal-backdrop" @click.self="closeDetailModal">
        <div class="drawer-panel">
          <div class="drawer-header">
            <div>
              <div class="drawer-title-row">
                <span class="drawer-badge">Kafedra ID: {{ activeDept?.departmentId }}</span>
                <h2 class="drawer-title">{{ activeDept?.kafedraName }}</h2>
              </div>
              <p class="drawer-sub">{{ activeDept?.facultyName }} &bull; O'quv yili: {{ selectedYear }}</p>
            </div>
            <button class="drawer-close-btn" @click="closeDetailModal" title="Yopish">✕</button>
          </div>

          <!-- Drawer Mini Summary -->
          <div class="drawer-mini-stats">
            <div class="mini-box bg-blue-50 border-blue-200">
              <span class="mini-label">Kafedra yuklamasi:</span>
              <span class="mini-val text-blue-700 font-bold">{{ formatHours(activeDept?.kafedra.jami) }} soat</span>
              <span class="mini-extra text-gray-500">Audit: {{ formatHours(activeDept?.kafedra.auditoriya) }} &bull; Tashqari: {{ formatHours(activeDept?.kafedra.tashqari) }}</span>
            </div>
            <div class="mini-box bg-emerald-50 border-emerald-200">
              <span class="mini-label">Shaxsiy ish reja:</span>
              <span class="mini-val text-emerald-700 font-bold">{{ formatHours(activeDept?.shaxsiyReja.jami) }} soat</span>
              <span class="mini-extra text-gray-500">Audit: {{ formatHours(activeDept?.shaxsiyReja.auditoriya) }} &bull; Tashqari: {{ formatHours(activeDept?.shaxsiyReja.tashqari) }}</span>
            </div>
            <div class="mini-box" :class="activeDeptDiffBoxClass">
              <span class="mini-label">Farq (Qoldiq):</span>
              <span class="mini-val font-bold" :class="activeDeptDiffTextClass">{{ formatDiffDisplay(activeDept?.diff.jami) }} soat</span>
              <span class="mini-extra font-medium">{{ activeDept?.statusLabel }}</span>
            </div>
          </div>

          <!-- Drawer Navigation Links -->
          <div class="drawer-quick-nav">
            <button class="btn-nav-link" @click="goToKafedraShaxsiyReja(activeDept)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
              Ushbu kafedraning Shaxsiy ish rejasiga o'tish
            </button>
            <button class="btn-nav-link btn-nav-secondary" @click="goToKafedraTaqsimoti(activeDept)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
              Kafedra taqsimot jadvaliga o'tish
            </button>
          </div>

          <!-- Drawer Tabs -->
          <div class="drawer-tabs">
            <button 
              class="tab-btn" 
              :class="{ 'active': activeTab === 'teachers' }" 
              @click="activeTab = 'teachers'"
            >
              O'qituvchilar taqsimoti ({{ detailLoading ? '...' : (detailData?.teachers || []).length }})
            </button>
            <button 
              class="tab-btn" 
              :class="{ 'active': activeTab === 'subjects' }" 
              @click="activeTab = 'subjects'"
            >
              Kafedra fanlar yuklamasi ({{ detailLoading ? '...' : (detailData?.subjects || []).length }})
            </button>
          </div>

          <!-- Tab Content -->
          <div class="drawer-body">
            <div v-if="detailLoading" class="py-12 text-center text-gray-500">
              <div class="spinner-small inline-block mr-2"></div>
              Ma'lumotlar yuklanmoqda...
            </div>

            <!-- 1-TAB: O'qituvchilar ro'yxati -->
            <div v-else-if="activeTab === 'teachers'">
              <div v-if="!detailData?.teachers || detailData.teachers.length === 0" class="py-8 text-center text-gray-400">
                Ushbu kafedrada shaxsiy ish reja biriktirilgan o'qituvchilar mavjud emas
              </div>
              <table v-else class="sub-detail-table">
                <thead>
                  <tr>
                    <th class="w-8">#</th>
                    <th class="text-left">O'qituvchi F.I.Sh</th>
                    <th class="text-center">Stavka</th>
                    <th class="text-center">Auditoriya</th>
                    <th class="text-center">Tashqari</th>
                    <th class="text-center font-bold">Jami soat</th>
                    <th class="text-center">Holati</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(t, idx) in detailData.teachers" :key="t.employeeId">
                    <td class="text-center text-gray-400">{{ idx + 1 }}</td>
                    <td class="font-medium text-gray-900">
                      <div class="font-semibold">{{ t.employeeName }}</div>
                      <div class="text-xs text-gray-500">{{ t.position }} &bull; {{ t.degree }}</div>
                    </td>
                    <td class="text-center text-sm">{{ t.stavka }}</td>
                    <td class="text-center text-blue-700 font-semibold">{{ t.auditoriyaSoati }}</td>
                    <td class="text-center text-indigo-700 font-semibold">{{ t.tashqariSoati }}</td>
                    <td class="text-center font-bold text-emerald-800 bg-emerald-50/50">{{ t.jamiSoati }}</td>
                    <td class="text-center">
                      <span class="status-pill-small" :class="getTeacherStatusClass(t.status)">
                        {{ getTeacherStatusText(t.status) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 2-TAB: Fanlar yuklamasi -->
            <div v-else-if="activeTab === 'subjects'">
              <div v-if="!detailData?.subjects || detailData.subjects.length === 0" class="py-8 text-center text-gray-400">
                Ushbu kafedrada fanlar yuklamasi topilmadi
              </div>
              <table v-else class="sub-detail-table">
                <thead>
                  <tr>
                    <th class="w-8">#</th>
                    <th class="text-left">Fan nomi</th>
                    <th class="text-left">Guruh</th>
                    <th class="text-center">Semestr</th>
                    <th class="text-center">Audit.</th>
                    <th class="text-center">Tashqari</th>
                    <th class="text-center font-bold">Jami</th>
                    <th class="text-center text-emerald-700">Taqsimlangan</th>
                    <th class="text-center">Qoldiq</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(s, idx) in detailData.subjects" :key="s._id || idx">
                    <td class="text-center text-gray-400">{{ idx + 1 }}</td>
                    <td class="font-medium text-gray-900">
                      <div>{{ s.subjectName }}</div>
                      <span v-if="s.subjectCode" class="text-xs text-gray-400">{{ s.subjectCode }}</span>
                    </td>
                    <td class="text-sm text-gray-700">{{ s.guruhNomi }}</td>
                    <td class="text-center text-xs text-gray-600 capitalize">{{ s.semestrTuri }}</td>
                    <td class="text-center text-blue-700">{{ s.auditoriyaSoati }}</td>
                    <td class="text-center text-indigo-700">{{ s.tashqariSoati }}</td>
                    <td class="text-center font-bold text-gray-900">{{ s.jamiSoati }}</td>
                    <td class="text-center font-bold text-emerald-700">{{ s.assignedHours }}</td>
                    <td class="text-center font-bold" :class="s.remainingHours === 0 ? 'text-emerald-600' : (s.remainingHours > 0 ? 'text-amber-600' : 'text-purple-600')">
                      {{ s.remainingHours }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

const API = process.env.VUE_APP_API_URL;

export default {
  name: "KafedraVsShaxsiyReja",
  data() {
    return {
      loading: false,
      selectedYear: "2026-2027",
      selectedSemestr: "hammasi",
      selectedFaculty: "",
      selectedStatus: "",
      searchQuery: "",
      summary: {},
      items: [],
      facultiesList: [],
      showDetailModal: false,
      activeDept: null,
      selectedDeptDetail: null,
      activeTab: "teachers",
      detailLoading: false,
      detailData: null
    };
  },
  computed: {
    filteredItems() {
      let list = this.items || [];

      if (this.selectedFaculty) {
        list = list.filter(item => Number(item.facultyId) === Number(this.selectedFaculty));
      }

      if (this.selectedStatus) {
        list = list.filter(item => item.status === this.selectedStatus);
      }

      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase().trim();
        list = list.filter(item => 
          (item.kafedraName || "").toLowerCase().includes(q) ||
          (item.facultyName || "").toLowerCase().includes(q) ||
          String(item.departmentId).includes(q)
        );
      }

      return list;
    },
    tableTotals() {
      let kafedraAudit = 0;
      let kafedraTashqari = 0;
      let kafedraJami = 0;

      let rejaAudit = 0;
      let rejaTashqari = 0;
      let rejaJami = 0;

      let totalTeachers = 0;

      for (const it of this.filteredItems) {
        kafedraAudit += it.kafedra.auditoriya;
        kafedraTashqari += it.kafedra.tashqari;
        kafedraJami += it.kafedra.jami;

        rejaAudit += it.shaxsiyReja.auditoriya;
        rejaTashqari += it.shaxsiyReja.tashqari;
        rejaJami += it.shaxsiyReja.jami;

        totalTeachers += it.shaxsiyReja.teachersCount;
      }

      const diffAudit = Number((kafedraAudit - rejaAudit).toFixed(1));
      const diffTashqari = Number((kafedraTashqari - rejaTashqari).toFixed(1));
      const diffJami = Number((kafedraJami - rejaJami).toFixed(1));
      const overallPercent = kafedraJami > 0 ? Number(((rejaJami / kafedraJami) * 100).toFixed(1)) : 0;

      return {
        kafedraAudit: Number(kafedraAudit.toFixed(1)),
        kafedraTashqari: Number(kafedraTashqari.toFixed(1)),
        kafedraJami: Number(kafedraJami.toFixed(1)),
        rejaAudit: Number(rejaAudit.toFixed(1)),
        rejaTashqari: Number(rejaTashqari.toFixed(1)),
        rejaJami: Number(rejaJami.toFixed(1)),
        diffAudit,
        diffTashqari,
        diffJami,
        overallPercent,
        totalTeachers
      };
    },
    summaryDiffClass() {
      const diff = this.summary.diff?.jami || 0;
      if (Math.abs(diff) <= 1.0) return "card-emerald";
      if (diff > 1.0) return "card-amber";
      return "card-purple";
    },
    summaryBadgeIconClass() {
      const diff = this.summary.diff?.jami || 0;
      if (Math.abs(diff) <= 1.0) return "icon-emerald";
      if (diff > 1.0) return "icon-amber";
      return "icon-purple";
    },
    summaryDiffTextClass() {
      const diff = this.summary.diff?.jami || 0;
      if (Math.abs(diff) <= 1.0) return "text-emerald-700";
      if (diff > 1.0) return "text-amber-700";
      return "text-purple-700";
    },
    activeDeptDiffBoxClass() {
      const diff = this.activeDept?.diff?.jami || 0;
      if (Math.abs(diff) <= 1.0) return "bg-emerald-50 border-emerald-200";
      if (diff > 1.0) return "bg-amber-50 border-amber-200";
      return "bg-purple-50 border-purple-200";
    },
    activeDeptDiffTextClass() {
      const diff = this.activeDept?.diff?.jami || 0;
      if (Math.abs(diff) <= 1.0) return "text-emerald-700";
      if (diff > 1.0) return "text-amber-700";
      return "text-purple-700";
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/kafedra-vs-shaxsiy-reja`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            oquvYili: this.selectedYear,
            semestrTuri: this.selectedSemestr
          }
        });

        if (res.data.success && res.data.data) {
          this.summary = res.data.data.summary || {};
          this.items = res.data.data.items || [];
          this.facultiesList = res.data.data.faculties || [];
        }
      } catch (err) {
        console.error("Error fetching comparison data:", err);
      } finally {
        this.loading = false;
      }
    },
    async openDepartmentDetail(dept) {
      this.activeDept = dept;
      this.selectedDeptDetail = dept;
      this.showDetailModal = true;
      this.detailLoading = true;
      this.activeTab = "teachers";
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/kafedra-vs-shaxsiy-reja/${dept.departmentId}`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { oquvYili: this.selectedYear }
        });
        if (res.data.success && res.data.data) {
          this.detailData = res.data.data;
        }
      } catch (err) {
        console.error("Error fetching department details:", err);
      } finally {
        this.detailLoading = false;
      }
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.activeDept = null;
      this.detailData = null;
    },
    goToKafedraShaxsiyReja(dept) {
      if (!dept) return;
      sessionStorage.setItem("shaxsiy_reja_selected_department", String(dept.departmentId));
      this.$router.push({
        path: "/shaxsiy-ish-reja",
        query: { departmentId: dept.departmentId }
      });
    },
    goToKafedraTaqsimoti(dept) {
      if (!dept) return;
      this.$router.push({
        path: "/taqsimot-jadval",
        query: {
          departmentId: dept.departmentId,
          oquvYili: this.selectedYear
        }
      });
    },
    clearFilters() {
      this.selectedFaculty = "";
      this.selectedStatus = "";
      this.searchQuery = "";
      this.selectedSemestr = "hammasi";
    },
    formatHours(val) {
      if (val === undefined || val === null || isNaN(val)) return "0";
      return Number(val).toLocaleString("uz-UZ");
    },
    formatDiffValue(val) {
      if (!val && val !== 0) return "0";
      const num = Number(val);
      if (num > 0) return `-${num}`;
      if (num < 0) return `+${Math.abs(num)}`;
      return "0";
    },
    formatDiffDisplay(val) {
      if (!val && val !== 0) return "0";
      const num = Number(val);
      if (num > 0) return `-${num}`;
      if (num < 0) return `+${Math.abs(num)}`;
      return "0";
    },
    getDiffCellClass(val) {
      const num = Number(val || 0);
      if (Math.abs(num) <= 0.5) return "text-emerald-600";
      if (num > 0.5) return "text-amber-600";
      return "text-purple-600";
    },
    getDiffTotalClass(val) {
      const num = Number(val || 0);
      if (Math.abs(num) <= 0.5) return "text-emerald-700 bg-emerald-50/50";
      if (num > 0.5) return "text-amber-700 bg-amber-50/50";
      return "text-purple-700 bg-purple-50/50";
    },
    getProgressBarColor(percent) {
      if (percent >= 99 && percent <= 101) return "#10b981"; // Yashil (100%)
      if (percent < 99) return "#f59e0b"; // Sariq (Kam taqsimlangan)
      return "#8b5cf6"; // Binafsha (Ortiqcha)
    },
    getStatusBadgeClass(status) {
      if (status === "MATCH") return "status-match";
      if (status === "UNDER") return "status-under";
      return "status-over";
    },
    getTeacherStatusClass(status) {
      if (!status) return "badge-waiting";
      if (Object.values(status).some(v => v === "rejected")) return "badge-rejected";
      if (status.oquv === "approved" || status.ilmiy === "approved" || status.yoshlar === "approved") return "badge-prorektor";
      if (status.dekan === "approved") return "badge-dekan";
      if (status.kafedra === "approved") return "badge-kafedra";
      if (status.teacher === "approved") return "badge-teacher";
      return "badge-waiting";
    },
    getTeacherStatusText(status) {
      if (!status) return "Kutilmoqda";
      if (Object.values(status).some(v => v === "rejected")) return "Rad etilgan";
      if (status.oquv === "approved" || status.ilmiy === "approved" || status.yoshlar === "approved") return "Prorektor tasdiqlagan";
      if (status.dekan === "approved") return "Dekan tasdiqlagan";
      if (status.kafedra === "approved") return "Kafedra tasdiqlagan";
      if (status.teacher === "approved") return "O'qituvchi tasdiqlagan";
      return "Kutilmoqda";
    },
    exportToExcel() {
      try {
        const rows = this.filteredItems.map((item, idx) => ({
          "№": idx + 1,
          "Kafedra": item.kafedraName,
          "Fakultet": item.facultyName,
          "Kafedra yuklamasi (Audit)": item.kafedra.auditoriya,
          "Kafedra yuklamasi (Tashqari)": item.kafedra.tashqari,
          "Kafedra yuklamasi (Jami)": item.kafedra.jami,
          "Shaxsiy reja (Audit)": item.shaxsiyReja.auditoriya,
          "Shaxsiy reja (Tashqari)": item.shaxsiyReja.tashqari,
          "Shaxsiy reja (Jami)": item.shaxsiyReja.jami,
          "Farq (Audit)": item.diff.auditoriya,
          "Farq (Tashqari)": item.diff.tashqari,
          "Farq (Jami)": item.diff.jami,
          "Taqsimot foizi (%)": `${item.diff.percent}%`,
          "O'qituvchilar soni": item.shaxsiyReja.teachersCount,
          "Holati": item.statusLabel
        }));

        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Kafedra_vs_Shaxsiy_Reja");
        XLSX.writeFile(wb, `Kafedra_vs_Shaxsiy_Reja_${this.selectedYear}.xlsx`);
      } catch (e) {
        console.error("Export error:", e);
        alert("Excel faylga eksport qilishda xatolik yuz berdi");
      }
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  background-color: #f8fafc;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.page-container {
  max-width: 1600px;
  margin: 0 auto;
}

/* Header */
.page-header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.page-main-title {
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
  margin: 0;
}

.page-subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-excel {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
}

.btn-excel:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.35);
}

.btn-refresh {
  background: #ffffff;
  color: #334155;
  border: 1px solid #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.btn-refresh:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #94a3b8;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* KPI Cards */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.kpi-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.kpi-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.kpi-label {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.kpi-icon-badge {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-blue { background: #eff6ff; color: #2563eb; }
.icon-indigo { background: #eef2ff; color: #4f46e5; }
.icon-emerald { background: #ecfdf5; color: #059669; }
.icon-amber { background: #fffbeb; color: #d97706; }
.icon-purple { background: #faf5ff; color: #9333ea; }

.kpi-value {
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
  margin-bottom: 6px;
}

.kpi-unit {
  font-size: 14px;
  font-weight: 500;
  color: #94a3b8;
}

.kpi-subtext {
  font-size: 12px;
  color: #64748b;
}

/* Filters */
.filters-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 16px 20px;
  border: 1px solid #e2e8f0;
  margin-bottom: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
}

.filters-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
}

.filter-item label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.filter-control {
  height: 40px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  font-size: 13px;
  color: #1e293b;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.filter-control:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.search-item {
  flex-grow: 1;
  min-width: 240px;
}

.search-input-wrap {
  position: relative;
  width: 100%;
}

.search-input-wrap input {
  width: 100%;
  padding-right: 32px;
}

.clear-search-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 14px;
}

.btn-clear-wrap {
  min-width: auto;
}

.btn-clear-filters {
  height: 40px;
  padding: 0 16px;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  color: #475569;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-clear-filters:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* Main Table */
.table-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.table-loading-box {
  padding: 80px 20px;
  text-align: center;
  color: #64748b;
}

.spinner-large {
  width: 42px;
  height: 42px;
  border: 3px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}

.spinner-small {
  width: 14px;
  height: 14px;
  border: 2px solid #cbd5e1;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.table-responsive {
  overflow-x: auto;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.comparison-table th {
  padding: 10px 12px;
  font-weight: 700;
  color: #334155;
  border: 1px solid #e2e8f0;
}

.thead-group-row {
  background-color: #f8fafc;
}

.th-group {
  text-align: center;
  font-size: 13px;
}

.th-kafedra-grp { background-color: #eff6ff; color: #1d4ed8; }
.th-reja-grp { background-color: #ecfdf5; color: #047857; }
.th-diff-grp { background-color: #fefce8; color: #854d0e; }

.thead-sub-row {
  background-color: #f1f5f9;
}

.th-sub {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #64748b;
  text-align: center;
}

.th-total-sub {
  font-weight: 800;
  color: #0f172a;
}

.comparison-row {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
  cursor: pointer;
}

.comparison-row:hover {
  background-color: #f8fafc;
}

.row-highlighted {
  background-color: #eff6ff !important;
}

.comparison-table td {
  padding: 12px 10px;
  border: 1px solid #f1f5f9;
}

.cell-name {
  max-width: 280px;
}

.name-box {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dept-title {
  color: #1e293b;
}

.dept-id-badge {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

.cell-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* Percent bar */
.cell-percent {
  min-width: 110px;
}

.percent-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-bar-bg {
  flex-grow: 1;
  height: 6px;
  background-color: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease;
}

.percent-text {
  font-size: 12px;
  min-width: 36px;
  text-align: right;
  color: #1e293b;
}

/* Status Badges */
.status-pill {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.status-match { background-color: #d1fae5; color: #065f46; }
.status-under { background-color: #fef3c7; color: #92400e; }
.status-over { background-color: #f3e8ff; color: #6b21a8; }

.btn-detail {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-detail:hover {
  background-color: #dbeafe;
  color: #1d4ed8;
}

/* Totals Footer */
.tfoot-totals td {
  background-color: #f8fafc;
  border-top: 2px solid #cbd5e1;
  padding: 14px 10px;
}

/* Drawer / Modal */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.drawer-panel {
  width: 100%;
  max-width: 850px;
  background: #ffffff;
  height: 100%;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.25s ease-out;
}

@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

.drawer-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #f8fafc;
}

.drawer-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.drawer-badge {
  background-color: #e2e8f0;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 4px;
}

.drawer-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.drawer-sub {
  font-size: 13px;
  color: #64748b;
  margin-top: 4px;
}

.drawer-close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #94a3b8;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.drawer-close-btn:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}

.drawer-mini-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #f1f5f9;
}

.mini-box {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mini-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
}

.mini-val {
  font-size: 18px;
}

.mini-extra {
  font-size: 11px;
}

.drawer-quick-nav {
  display: flex;
  gap: 12px;
  padding: 12px 24px;
  background-color: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.btn-nav-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-nav-link:hover {
  background-color: #2563eb;
}

.btn-nav-secondary {
  background-color: #ffffff;
  color: #334155;
  border: 1px solid #cbd5e1;
}

.btn-nav-secondary:hover {
  background-color: #f1f5f9;
}

.drawer-tabs {
  display: flex;
  padding: 0 24px;
  border-bottom: 1px solid #e2e8f0;
  background-color: #ffffff;
}

.tab-btn {
  padding: 14px 18px;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  border: none;
  background: none;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}

.tab-btn.active {
  color: #2563eb;
}

.tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #2563eb;
}

.drawer-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px 24px;
}

.sub-detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.sub-detail-table th {
  background-color: #f8fafc;
  padding: 8px 10px;
  font-weight: 700;
  color: #475569;
  border-bottom: 2px solid #e2e8f0;
}

.sub-detail-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #f1f5f9;
}

.status-pill-small {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
}

.badge-waiting { background: #fef3c7; color: #92400e; }
.badge-rejected { background: #fee2e2; color: #991b1b; }
.badge-teacher { background: #e0f2fe; color: #0369a1; }
.badge-kafedra { background: #fef9c3; color: #854d0e; }
.badge-dekan { background: #e0e7ff; color: #3730a3; }
.badge-prorektor { background: #d1fae5; color: #065f46; }

@media (max-width: 900px) {
  .page-header-box { flex-direction: column; align-items: flex-start; }
  .drawer-mini-stats { grid-template-columns: 1fr; }
  .drawer-quick-nav { flex-direction: column; }
}
</style>
